
/* External dependencies */
import { API } from 'aws-amplify';

/* Internal dependencies */
import { ApiName } from '../aws-exports';

export const getTasteTestForUser = async (userId: string) =>
  await API.get(ApiName.bmApp, `/taste-test/getTasteTestForUser/${userId}`, null);